module.exports = __webpack_public_path__ + "media/images/stock_groups/e88a-bafa5b267f305762b0e4c6fa01f484d3.svg";